module.exports = __webpack_public_path__ + "static/img/ip@2x.de3c670b.png";